import { Badge } from '@/components/ui/badge';

interface SubscriptionBadgeProps {
  status: 'active' | 'suspended' | 'cancelled' | 'trial';
  className?: string;
}

export function SubscriptionBadge({ status, className }: SubscriptionBadgeProps) {
  const variants: Record<string, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; label: string }> = {
    active: { variant: 'default', label: 'Active' },
    trial: { variant: 'secondary', label: 'Trial' },
    suspended: { variant: 'outline', label: 'Suspended' },
    cancelled: { variant: 'destructive', label: 'Cancelled' },
  };

  const config = variants[status] || variants.active;

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
